module.exports = __webpack_public_path__ + "img/40200.fb75c4b6.jpg";